<template>
  <!-- <v-hover v-slot:default="{ hover }"> -->
  <v-card v-bind="$attrs" v-on="$listeners" outlined hover :style="computedStyle">
    <!-- :elevation="hover ? 3 : 0" -->
    <!-- hover -->
    <template v-for="(index, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
  </v-card>
  <!-- </v-hover> -->
</template>

<script>
export default {
  props: {
    conspicuity: {
      type: String,
      default: '',
      required: false,
    },
  },

  data: () => ({
    //
  }),

  computed: {
    computedStyle() {
      let style = {}
      switch (this.conspicuity) {
        case 'higher':
          style = {
            border: 'var(--v-primary-base)',
          }
          break
        case 'lower':
          style = {
            opacity: '0.6',
          }
          break
        default:
      }
      return style
    },
  },

  methods: {
    //
  },
}
</script>

<style scoped></style>
